/* eslint-disable camelcase */
/* eslint-disable react/jsx-key */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import {
    HasProduct,
    HasProductContext,
    withProduct,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import updateAccountSettings from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import translate from "@insite/client-framework/Translate";
import { AvailabilityDto, AvailabilityMessageType, ProductModel } from "@insite/client-framework/Types/ApiModels";
import PageProps from "@insite/client-framework/Types/PageProps";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductSelector from "@insite/content-library/Components/ProductSelector";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import X from "@insite/mobius/Icons/X";
import LazyImage from "@insite/mobius/LazyImage";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { SelectPresentationProps } from "@insite/mobius/Select";
import TextArea from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import submitRFQAForm from "@tSchaedlerYesco/Handlers/RFQAHandler";
import ProductBrand from "@tSchaedlerYesco/Overrides/Components/ProductBrand";
import cloneDeep from "lodash/cloneDeep";
import React, { ChangeEvent, FC, useContext, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    isLoading?: boolean;
    showPrice: boolean;
    showAvailability: boolean;
    showAddToList: boolean;
    showBrand: boolean;
    availability?: AvailabilityDto;
}

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    return {
        productSettings: getSettingsCollection(state).productSettings,
        canViewRfqa: isAuthenticated,
        currentUserIsGuest: getCurrentUserIsGuest(state),
        userName: state.context.session.userName,
        showInventory: state.context.showInventory,
    };
};

const mapDispatchToProps = { loadProducts, submitRFQAForm };
// interface OwnProps extends PageProps {}

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    HasProduct &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
    createListModal?: ModalPresentationProps;
    boldTextSpan?: TypographyPresentationProps;
    TitleBoldWrapper?: TypographyPresentationProps;
    divWrapContainer?: GridItemProps;
    ProductImageFirstWrapper?: InjectableCss;
    SearchResultWrapper?: InjectableCss;
    Imagewrapper?: InjectableCss;
    ClickableWrapper?: InjectableCss;
    ImageTitlewrapper?: InjectableCss;
    ProdMFQstyles?: InjectableCss;
    Componet1?: InjectableCss;
    Componet2?: InjectableCss;
    QtyContainer1?: InjectableCss;
    QtyContainer2?: InjectableCss;
    SearchIconTitle?: InjectableCss;
    RemoveWrapper?: InjectableCss;
    ButtonWrapper?: InjectableCss;
    ButtonDivWrapper?: InjectableCss;
    ButtonnoProductsDivWrapper?: InjectableCss;
    SkuMfgwrapper?: InjectableCss;
    noResultWrapper?: InjectableCss;
    procuctSearchImageTitlewrapper?: InjectableCss;
    procuctSearchTitleSkuwrapper?: InjectableCss;
    CheckboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
}

export const actionsStyles: ProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 20px;
            `,
        },
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 10px;
            margin-bottom: 10px;
        `,
    },
    addToCartButton: {
        css: css`
            width: 80%;
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 10px;
                width: 4.1rem;
                min-width: 4.1rem;
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: 10px;
            min-height: 2rem;
            background-color: #4599d2 !important;
            justify-content: center;
            span {
                color: white !important;
                font-weight: bold;
            }
            padding: 8px;
        `,
    },
    createListModal: {
        closeButtonProps: {
            shape: "rounded",
            buttonType: "solid",
            size: 36,

            css: css`
                border: 2px solid #525252;
                border-radius: 50%;
                background-color: black;
                padding: 6px;
                margin-right: 10px;
                margin-top: 5px;
                margin-bottom: 2px;
                &:hover {
                    border: 2px solid #525252;
                    border-radius: 50%;
                }
            `,
        },

        closeButtonIconProps: {
            src: "X",
            size: 24,
            color: "#0000",
            css: css`
                svg {
                    color: #ffff !important;
                }
            `,
        },
        cssOverrides: {
            modalContent: css`
                padding: 10px 20px 20px 20px;
            `,
            modalTitle: css`
                padding: 10px 15px 10px 20px;
                color: #3666b1;
            `,
            headlineTypography: css`
                font-size: 26px;
                margin-bottom: 5px;
                color: #3666b1;
            `,
        },
    },
    boldTextSpan: {
        css: css`
            font-weight: bold;
            margin-bottom: 20px;
            font-size: 22px;
            color: #3666b1;
        `,
    },
    TitleBoldWrapper: {
        css: css`
            font-weight: 500;
            font-size: 20px;
            color: rgb(54, 102, 177);
        `,
    },
    ClickableWrapper: {
        css: css`
            display: flex;
            justify-content: right;
            margin-left: 30px;
        `,
    },
    divWrapContainer: {
        css: css`
            display: grid;
            grid-template-columns: repeat(2, 100fr);
            grid-gap: 10px;
            padding: 0px;
            max-width: 100%;
            flex-basis: auto;
            width: 100%;
            margin-bottom: 10px !important;
        `,
    },
    ProductImageFirstWrapper: {
        css: css`
            margin-top: 10px;
            background-color: #f5f5f5;
            padding: 10px;
            margin-bottom: 10px;
        `,
    },
    SearchResultWrapper: {
        css: css`
            background-color: #ffff; ;
        `,
    },
    ImageTitlewrapper: {
        css: css`
            display: flex;
            gap: 15px;
        `,
    },
    ProdMFQstyles: {
        css: css`
            display: flex;
            gap: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        gap: 0;
                    `,
                    css`
                        flex-direction: column;
                        gap: 0;
                    `,

                    null,
                    null,
                ])}
        `,
    },
    Componet1: {
        css: css`
            display: flex;
            flex: 1;
            justify-content: space-between;
        `,
    },
    Componet2: {
        css: css`
            width: 168px;
        `,
    },
    SearchIconTitle: {
        css: css`
            display: flex;
        `,
    },
    RemoveWrapper: {
        css: css`
            display: flex;
            align-items: start;
            align-self: flex-start;
        `,
    },
    ButtonWrapper: {
        css: css`
            justify-content: flex-end;
            height: 40px;
            background-color: green;
            border: none;
        `,
    },
    ButtonDivWrapper: {
        css: css`
            justify-content: flex-end;
            display: flex;
            margin-right: 35px;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-right: 5px;
                        width: 30%;
                    `,
                    css`
                        margin-right: 5px;
                        width: 30%;
                    `,

                    null,
                    null,
                ])}
        `,
    },
    ButtonnoProductsDivWrapper: {
        css: css`
            justify-content: flex-end;
            display: flex;
            align-items: center;
            margin-bottom: 15px;
        `,
    },
    SkuMfgwrapper: {
        css: css`
            display: flex;
            gap: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 0px;
                        flex-direction: column;
                    `,
                    css`
                        gap: 0px;
                        flex-direction: column;
                    `,

                    null,
                    null,
                ])}
        `,
    },
    noResultWrapper: {
        css: css`
            display: flex;
        `,
    },
    procuctSearchImageTitlewrapper: {
        css: css`
            display: flex;
            gap: 15px;
            justify-content: space-around;
            /* background-color: #f8f8f8; */
        `,
    },
    QtyContainer1: {
        css: css`
            margin-right: 38px;
        `,
    },
    QtyContainer2: {
        css: css`
            margin-left: 180px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 5px;
                    `,

                    null,
                    null,
                ])}
        `,
    },
    procuctSearchTitleSkuwrapper: {
        css: css`
            display: flex;
            gap: 15px;
            flex-direction: column;
            flex: 1;
        `,
    },
    Imagewrapper: {
        css: css`
            height: 90px;
            width: 15%;
            img {
                width: 70%;
                height: auto;
            }
        `,
    },
    CheckboxGroup: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 20px;
            margin-bottom: 15px;
        `,
    },
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({
    productContext,
    productSettings,
    showPrice,
    showAvailability,
    showAddToList,
    canViewRfqa,
    availability,
    isLoading,
    userName,
    product,
    productInfo,
    showBrand,
    showInventory,
    loadProducts,
    submitRFQAForm,
}) => {
    // Site messages
    const firstNameMessage = siteMessage("Full Name Required");
    const companymessage = siteMessage("Company Required");
    const cityMessage = siteMessage("City Required");
    const stateMessage = siteMessage("State Required");
    // const notesMessage = siteMessage("Special Message Required");
    const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
    const PhoneMessage = siteMessage("Phone number Required");
    const extensionMessage = siteMessage("Extension Required");
    const communicationMessage = siteMessage("communication Required");

    //
    const [createListModalIsOpen, newcreateListModalIsOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [firstName, setfirstName] = React.useState("");
    const [company, setCompany] = React.useState("");
    const [City, setCity] = React.useState("");
    const [State, setState] = React.useState("");
    const [Email, setEmail] = React.useState("");
    const [noProducts, setNoProducts] = React.useState("");
    const [phone, setPhoneNo] = React.useState("");
    const [Notes, setNotes] = React.useState("");
    const [qty, setQTY] = React.useState("1");
    const [searchResultProducts, setSearchResultProducts] = useState<ProductModel[] | null>(null);
    const [searchText, setSearchText] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [newProductList, setNewProductList] = useState<any[]>([]);
    const [additionalProducts, setAdditionalProducts] = useState<any[]>([]);
    const [loadSpinner, setloadSpinner] = React.useState(false);
    const [preferredCommunicationMethod, setPreferredCommunicationMethod] = React.useState([
        {
            name: "Email",
            value: "Email",
            isChecked: false,
        },
        {
            name: "Phone",
            value: "Phone",
            isChecked: false,
        },
    ]);
    const [preferredCommunicationMethodParams, setPreferredCommunicationMethodParams] = React.useState<string[]>([]);
    // ERRORS

    const [firstnameerror, setFirstNameError] = React.useState(firstNameMessage);
    const [companyerror, setcompanyerror] = React.useState(companymessage);
    const [cityError, setCityError] = React.useState(cityMessage);
    const [stateError, setStateError] = React.useState(stateMessage);
    // const [notesError, setNotesError] = React.useState(notesMessage);
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [phoneerror, setphoneerror] = React.useState(PhoneMessage);
    const [extensionError, setExtensionError] = React.useState(extensionMessage);
    const [communicationError, setCommunicationError] = React.useState(communicationMessage);

    //
    const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;
    const modalCloseHandler = () => {
        newcreateListModalIsOpen(false);
    };
    const buttonClickHandler = () => {
        newcreateListModalIsOpen(true);
        setIsOpen(true);
    };

    const availability1 =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    const StyledForm = getStyledWrapper("form");

    // FormFields

    // FIRST NAME
    const validateFirstNameType = (firstName: string) => {
        const firstnameerror = !firstName || firstName?.length <= 0 ? (firstNameMessage as string) : "";
        setFirstNameError(firstnameerror);
        return !firstnameerror;
    };
    const firstnameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setfirstName(event.target.value);
        validateFirstNameType(event.target.value);
    };

    // COMPANY
    const validatecompanyType = (company: string) => {
        const companyerror = !company || company?.length <= 0 ? (companymessage as string) : "";
        setcompanyerror(companyerror);
        return !companyerror;
    };
    const companyChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setCompany(event.target.value);
        validatecompanyType(event.target.value);
    };

    // City
    const validateCityType = (cityName: string) => {
        const cityNameError = !cityName || cityName?.length <= 0 ? (cityMessage as string) : "";
        setCityError(cityNameError);
        return !cityNameError;
    };
    const cityChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateCityType(event.target.value);
        setCity(event.target.value);
    };
    // State

    const validateStateType = (stateName: string) => {
        const stateNameError = !stateName || stateName?.length <= 0 ? (stateMessage as string) : "";
        setStateError(stateNameError);
        return !stateNameError;
    };
    const stateChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateStateType(event.target.value);
        setState(event.target.value);
    };

    // EMAIL

    const validateEmail = (Email: string) => {
        const emailError = !Email ? emailRequiredFieldMessage : emailRegexp.test(Email) ? "" : emailFieldMessage;
        setEmailError(emailError as any);
        return !emailError;
    };

    const emailChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateEmail(event.target.value);
        setEmail(event.currentTarget.value);
        updateAccountSettings({ email: event.currentTarget.value });
    };

    // PHONE NUMBER
    const validatephoneType = (phone: string) => {
        const PHONE_NO_REGEX = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/i;
        const phoneerror = !(phone && PHONE_NO_REGEX.test(phone)) ? (PhoneMessage as string) : "";
        setphoneerror(phoneerror);
        return !phoneerror;
    };

    const phoneChangeHandler = (phone: string) => {
        const numericPhone = phone.replace(/\D/g, ""); // Remove non-numeric characters
        setPhoneNo(numericPhone);
        validatephoneType(numericPhone);
    };
    // Notes

    // const validateNotesType = (notes: string) => {
    //     const notesNameError = !notes || notes?.length <= 0 ? (notesMessage as string) : "";
    //     setNotesError(notesNameError);
    //     return !notesNameError;
    // };
    const notesChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        // validateNotesType(event.target.value);
        setNotes(event.target.value);
    };
    // Communication method

    const validateCommunicationType = (communication: any) => {
        const communicationTypeError =
            !communication || communication?.length <= 0 ? (communicationMessage as string) : "";
        setCommunicationError(communicationTypeError);
        return !communicationTypeError;
    };

    const CommunicationMethodHandler = (value: string) => {
        const updatedCommunication =
            preferredCommunicationMethod &&
            preferredCommunicationMethod.map(val => {
                if (val.value === value) {
                    val.isChecked = !val.isChecked;
                }
                return val;
            });
        const communicationParams = updatedCommunication
            .filter(CommunicationIsSelected => {
                return CommunicationIsSelected.isChecked;
            })
            .map(val => {
                return `${val.name}, `;
            });
        validateCommunicationType(communicationParams);
        setPreferredCommunicationMethod(updatedCommunication);
        setPreferredCommunicationMethodParams(communicationParams);
    };

    const searchProducts = () => {
        if (searchText.trim()) {
            loadProducts({
                searchWithin: searchText,
                // pageSize: 5,
                onSuccess(result) {
                    const sliceData = result.length > 5 ? result.slice(0, 5) : result;
                    const sperateNewProductListId =
                        newProductList.length &&
                        newProductList.map(item => {
                            return item.id;
                        });

                    const filterDataProduct =
                        sperateNewProductListId &&
                        sliceData.filter(productItem => {
                            return !sperateNewProductListId.includes(productItem.id);
                        });
                    setSearchResultProducts(filterDataProduct || sliceData);
                    // setSearchText("");
                },
            });
        }
    };
    // Qty

    const keyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === 13) {
            (event.target as any).blur();
        }
    };

    const qtyChangeHandler = (productId: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;

        const productsMap = newProductList.map((product: ProductModel) => {
            if (productId === product.id) {
                return {
                    ...product,
                    properties: {
                        ...product.properties,
                        qty: value,
                    },
                };
            }
            return product;
        });

        setNewProductList(productsMap);
    };

    //
    const removeProducts = (id: string | Number) => {
        searchResultProducts;
        const filterRemoveData = newProductList.filter(val => {
            return val.id !== id;
        });
        const removedProduct = newProductList.find(val => {
            return val.id === id;
        });
        setNewProductList([...filterRemoveData]);
        searchResultProducts && setSearchResultProducts([...searchResultProducts, removedProduct]);
    };

    const validateSubmitEnabled = () => {
        return !(
            firstnameerror ||
            companyerror ||
            cityError ||
            stateError ||
            // notesError ||
            emailError ||
            phoneerror ||
            communicationError
        );
    };
    const test = () => {
        setfirstName(" ");
        setCity("");
        setCompany("");
        setEmail("");
        setNotes("");
        setPhoneNo("");
        setState("");
        setQTY("1");
        setSearchResultProducts(null);
        setNewProductList([]);
        setSearchText("");
        setPreferredCommunicationMethodParams([]);
        setAdditionalProducts([]);
    };

    const vald = () => {
        validateFirstNameType(firstName);
        validatecompanyType(company);
        validateCityType(City);
        validateStateType(State);
        validateEmail(Email);
        validatephoneType(phone);
        validateCommunicationType(preferredCommunicationMethodParams);
    };
    const clubProducts = () => {
        const updatedProduct = cloneDeep(product);
        updatedProduct.properties.qty = qty || "1";

        const finalClubProducts = [...newProductList, updatedProduct];
        const mapProduct = finalClubProducts.map((item: ProductModel) => {
            return {
                ProductNumber: item.productTitle,
                productMFG: item.manufacturerItem,
                productSKU: item.productNumber,
                quantity: item.properties.qty || "1",
            };
        });
        return mapProduct;
    };

    const FinalProduct = clubProducts();
    const toasterContext = useContext(ToasterContext);

    const updateSettingsHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        clubProducts();
        vald();
        event.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            // window.scrollTo(0, 0);
            toasterContext.addToast({ body: translate("Please fill all required fields"), messageType: "danger" });
            return;
        }
        const obj: any = {
            firstName,
            company,
            City,
            State,
            Email,
            phone,
            preferredCommunicationMethodParams,
        };

        // Datalayer

        const dataLayer = (window as any).dataLayer || [];
        const request_quote_items = FinalProduct.map(rfqa => {
            return {
                item_id: rfqa.productSKU,
                item_brand: rfqa.productMFG,
                item_name: rfqa.ProductNumber,
                price: 0,
                quantity: rfqa.quantity,
            };
        });
        dataLayer.push({
            event: "request_quote",
            ecommerce: {
                currency: "USD",
                value: 0,
                request_quote_items,
            },
        });

        submitRFQAForm({
            type: "NonStockProductsRFQ",
            fullName: firstName,
            companyName: company,
            city: City,
            state: State,
            email: Email,
            phoneNumber: phone,
            preferredCommunicationMethod: preferredCommunicationMethodParams,
            notes: Notes,
            products: FinalProduct,
            additionalRequestedProduct: additionalProducts,
            onSuccess: () => {
                modalCloseHandler();
                toasterContext.addToast({ body: translate("Successfull"), messageType: "success" });
                test();
            },
            onComplete() {
                this.onSuccess?.();
                modalCloseHandler();
                test();
                // toasterContext.addToast({ body: translate("Successfull"), messageType: "success" });
            },
        });
    };
    const updateProducts = (product: any, id: String | Number) => {
        const updatedList = [...newProductList, product];
        const filterSearchProduct =
            searchResultProducts &&
            searchResultProducts.filter(val => {
                return val.id !== id;
            });
        setNewProductList(updatedList);
        searchResultProducts && setSearchResultProducts(filterSearchProduct);
    };
    const updateNoSearchResultProducts = (event: any) => {
        setNoProducts(event.target.value);
    };

    const handleAddToQuote = () => {
        setAdditionalProducts([...additionalProducts, noProducts]);
        setNoProducts("");
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* {showPrice && (
                <>
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.price}
                    />
                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                </>
            )} */}

            {showPrice && !userName && availability1?.messageType === 2 ? (
                <></>
            ) : (
                <>
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.price}
                    />
                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                </>
            )}

            {!canViewRfqa && !userName && availability1?.messageType === 2 ? (
                <>
                    <Button onClick={buttonClickHandler}>{translate("Request Quote")}</Button>

                    {isOpen && (
                        <Modal
                            headline="Request a Quote"
                            {...styles.createListModal}
                            isOpen={createListModalIsOpen}
                            handleClose={modalCloseHandler}
                        >
                            <>
                                <StyledForm>
                                    <StyledWrapper {...styles.boldTextSpan}>
                                        {translate(" Contact Information:")}
                                    </StyledWrapper>
                                    <GridItem {...styles.divWrapContainer}>
                                        <TextField
                                            type="text"
                                            label={translate("FULL NAME ")}
                                            maxLength={256}
                                            required
                                            onChange={firstnameChangeHandler}
                                            value={firstName}
                                            error={isSubmitted && firstnameerror}
                                        />

                                        <TextField
                                            type="text"
                                            label={translate("COMPANY ")}
                                            value={company}
                                            error={isSubmitted && companyerror}
                                            required
                                            onChange={companyChangeHandler}
                                        ></TextField>
                                    </GridItem>
                                    <GridItem {...styles.divWrapContainer}>
                                        <TextField
                                            type="text"
                                            label={translate("CITY ")}
                                            value={City}
                                            error={isSubmitted && cityError}
                                            required
                                            onChange={cityChangeHandler}
                                        ></TextField>
                                        <TextField
                                            type="text"
                                            label={translate("STATE ")}
                                            value={State}
                                            error={isSubmitted && stateError}
                                            required
                                            onChange={stateChangeHandler}
                                        ></TextField>
                                    </GridItem>
                                    <GridItem {...styles.divWrapContainer}>
                                        <TextField
                                            type="Email"
                                            label={translate("E-mail")}
                                            onChange={emailChangeHandler}
                                            value={Email}
                                            required
                                            maxLength={256}
                                            error={isSubmitted && emailError}
                                        />

                                        <TextField
                                            type="text"
                                            label={translate("Phone Number")}
                                            value={phone}
                                            error={isSubmitted && phoneerror}
                                            required
                                            onChange={e => phoneChangeHandler(e.target.value)}
                                        ></TextField>
                                    </GridItem>
                                </StyledForm>
                                <StyledWrapper {...styles.ProductImageFirstWrapper}>
                                    <StyledWrapper {...styles.boldTextSpan}>
                                        {translate(" ADD PRODUCT(S) TO QUOTE : ")}
                                    </StyledWrapper>

                                    <StyledWrapper {...styles.SearchIconTitle}>
                                        <TextField
                                            value={searchText}
                                            onKeyPress={keyPressHandler}
                                            onChange={event => setSearchText(event.currentTarget.value)}
                                            placeholder={translate(
                                                "Search by product name, part number or description",
                                            )}
                                            type="text"
                                            data-test-selector="productListSearchWithin"
                                            id="productsKeywordSearch"
                                        />
                                        <Button onClick={searchProducts}>
                                            <Icon src={Search} />
                                        </Button>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.SearchResultWrapper}>
                                        {searchResultProducts?.length ? (
                                            <StyledWrapper>
                                                {searchResultProducts.map(product => (
                                                    <>
                                                        <StyledWrapper
                                                            {...styles.procuctSearchImageTitlewrapper}
                                                            key={product.id}
                                                        >
                                                            <LazyImage
                                                                {...styles.Imagewrapper}
                                                                src={product.mediumImagePath}
                                                            ></LazyImage>
                                                            <StyledWrapper {...styles.procuctSearchTitleSkuwrapper}>
                                                                <StyledWrapper {...styles.TitleBoldWrapper}>
                                                                    {product.productTitle}
                                                                </StyledWrapper>
                                                                <StyledWrapper {...styles.SkuMfgwrapper}>
                                                                    <StyledWrapper>
                                                                        <p> {`MFG:  ${product.manufacturerItem}`}</p>
                                                                    </StyledWrapper>
                                                                    <StyledWrapper>
                                                                        <p> {`SKU:  ${product.productNumber}`}</p>
                                                                    </StyledWrapper>
                                                                </StyledWrapper>
                                                            </StyledWrapper>
                                                            <StyledWrapper {...styles.ButtonDivWrapper}>
                                                                <Button
                                                                    onClick={() => {
                                                                        updateProducts(product, product.id);
                                                                    }}
                                                                    {...styles.ButtonWrapper}
                                                                >
                                                                    {translate(" ADD TO QUOTE ")}
                                                                </Button>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                        <hr></hr>
                                                    </>
                                                ))}
                                            </StyledWrapper>
                                        ) : (
                                            <>
                                                {searchResultProducts?.length === 0 && (
                                                    <>
                                                        <LoadingOverlay loading={loadSpinner}></LoadingOverlay>
                                                        <StyledWrapper {...styles.boldTextSpan}>
                                                            {translate("Cant Find what you are Looking for? ")}
                                                        </StyledWrapper>
                                                        <StyledWrapper {...styles.noResultWrapper}>
                                                            <TextField
                                                                placeholder={translate(
                                                                    "Type Product Number, SKU or MFG",
                                                                )}
                                                                onChange={updateNoSearchResultProducts}
                                                                value={noProducts}
                                                                maxLength={256}
                                                            />
                                                            <StyledWrapper {...styles.ButtonnoProductsDivWrapper}>
                                                                <Button
                                                                    onClick={handleAddToQuote}
                                                                    disabled={!noProducts.trim()}
                                                                    {...styles.ButtonWrapper}
                                                                >
                                                                    {translate(" ADD TO QUOTE ")}
                                                                </Button>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </StyledWrapper>
                                    <br></br>
                                    <StyledWrapper {...styles.boldTextSpan}>
                                        {translate("  Quote Details : ")}
                                    </StyledWrapper>
                                    <hr></hr>

                                    <StyledWrapper {...styles.ImageTitlewrapper}>
                                        <LazyImage {...styles.Imagewrapper} src={product.mediumImagePath}></LazyImage>
                                        <StyledWrapper {...styles.Componet1}>
                                            <StyledWrapper {...styles.procuctSearchTitleSkuwrapper}>
                                                <Typography {...styles.TitleBoldWrapper}>
                                                    {product.productTitle}
                                                </Typography>
                                                <StyledWrapper {...styles.ProdMFQstyles}>
                                                    {/* {product.brand && showBrand && <ProductBrand brand={product.brand} />} */}
                                                    <p> {`MFG:  ${product.manufacturerItem}`}</p>
                                                    <p> {`SKU:  ${product.productNumber}`}</p>
                                                    <br />
                                                </StyledWrapper>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.QtyContainer1}>
                                                <TextField
                                                    label={translate("QTY")}
                                                    type="number"
                                                    min={1}
                                                    max={999999}
                                                    value={qty} // Access quantity for corresponding product
                                                    onKeyPress={keyPressHandler}
                                                    onChange={event => setQTY(event.target.value)}
                                                    data-test-selector="product_qtyOrdered"
                                                    {...styles}
                                                />
                                            </StyledWrapper>
                                            <Clickable {...styles.RemoveWrapper}>
                                                <StyledWrapper></StyledWrapper>
                                                {/* <Icon src={} /> */}
                                            </Clickable>
                                        </StyledWrapper>
                                    </StyledWrapper>

                                    <hr></hr>
                                    <StyledWrapper>
                                        {newProductList?.length ? (
                                            <StyledWrapper>
                                                {newProductList.map((product: ProductModel) => (
                                                    <>
                                                        <StyledWrapper key={product.id} {...styles.ImageTitlewrapper}>
                                                            <LazyImage
                                                                {...styles.Imagewrapper}
                                                                src={product.mediumImagePath}
                                                            ></LazyImage>
                                                            <StyledWrapper {...styles.Componet1}>
                                                                <StyledWrapper {...styles.procuctSearchTitleSkuwrapper}>
                                                                    <Typography {...styles.TitleBoldWrapper}>
                                                                        {product.productTitle}
                                                                    </Typography>
                                                                    <StyledWrapper {...styles.ProdMFQstyles}>
                                                                        <Typography>
                                                                            {" "}
                                                                            {`MFG:  ${product.manufacturerItem}`}
                                                                        </Typography>
                                                                        <Typography>
                                                                            {" "}
                                                                            {`SKU:  ${product.productNumber}`}
                                                                        </Typography>
                                                                        <br />
                                                                    </StyledWrapper>
                                                                </StyledWrapper>
                                                                <StyledWrapper {...styles.QtyContainer2}>
                                                                    <TextField
                                                                        label={translate("QTY")}
                                                                        type="number"
                                                                        min={1}
                                                                        max={999999}
                                                                        value={product.properties.qty || "1"} // Access quantity for corresponding product
                                                                        onKeyPress={keyPressHandler}
                                                                        onChange={event =>
                                                                            qtyChangeHandler(product.id, event)
                                                                        }
                                                                        data-test-selector={`product_qtyOrdered_${product.customerProductNumber}`}
                                                                        {...styles}
                                                                    />
                                                                </StyledWrapper>
                                                            </StyledWrapper>
                                                            <Clickable
                                                                {...styles.RemoveWrapper}
                                                                onClick={() => {
                                                                    removeProducts(product.id);
                                                                }}
                                                            >
                                                                <Icon src={X} />
                                                            </Clickable>
                                                        </StyledWrapper>

                                                        <hr></hr>
                                                    </>
                                                ))}
                                            </StyledWrapper>
                                        ) : (
                                            <StyledWrapper></StyledWrapper>
                                        )}
                                        {additionalProducts && additionalProducts.length ? (
                                            <StyledWrapper>
                                                <StyledWrapper {...styles.boldTextSpan}>
                                                    {translate("REQUESTED PRODUCTS: ")}
                                                </StyledWrapper>
                                                <StyledWrapper>
                                                    {additionalProducts.map((text, index) => (
                                                        <>
                                                            <Typography key={index} {...styles.TitleBoldWrapper}>
                                                                <ul style={{ listStyleType: "disc" }}>
                                                                    <li style={{ marginLeft: "20px" }}>{text}</li>
                                                                </ul>
                                                            </Typography>
                                                        </>
                                                    ))}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ) : (
                                            ""
                                        )}
                                    </StyledWrapper>
                                </StyledWrapper>
                                <StyledWrapper {...styles.boldTextSpan}>
                                    {translate(" ADDITIONAL PREFERENCES :")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.boldTextSpan}>
                                    {translate(" Prefered method of communication :")}
                                </StyledWrapper>
                                <CheckboxGroup {...styles.CheckboxGroup} error={isSubmitted && communicationError}>
                                    {preferredCommunicationMethod &&
                                        preferredCommunicationMethod.map(communication => (
                                            <StyledWrapper {...styles.ImageTitlewrapper}>
                                                <StyledWrapper> {communication.name}</StyledWrapper>

                                                <Checkbox
                                                    key={communication.name}
                                                    checked={communication.isChecked}
                                                    onChange={() => CommunicationMethodHandler(communication.value)}
                                                ></Checkbox>
                                            </StyledWrapper>
                                        ))}
                                </CheckboxGroup>
                                <StyledWrapper {...styles.boldTextSpan}>
                                    {translate("SPECIAL INSTRUCTIONS : ")}
                                </StyledWrapper>
                                <TextArea
                                    onChange={notesChangeHandler}
                                    // error={isSubmitted && notesError}
                                    value={Notes}
                                ></TextArea>

                                <Button onClick={updateSettingsHandler}>SUBMIT</Button>
                            </>
                        </Modal>
                    )}
                </>
            ) : (
                <>
                    <StyledWrapper {...styles.addToCartWrapper}>
                        <ProductQuantityOrdered extendedStyles={styles.quantityOrdered} />
                        <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />
                    </StyledWrapper>
                    <ProductAddToCartButton
                        data-test-selector={`actionsAddToCart${productContext.product.id}`}
                        extendedStyles={styles.addToCartButton}
                    />
                </>
            )}
            {showAddToList && (
                <ProductAddToListLink
                    {...styles.addToListWrapper}
                    data-test-selector={`actionsAddToList${productContext.product.id}`}
                    extendedStyles={styles.addToListLink}
                />
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(withProduct(ProductListActions)));
